// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Collections.scss';
import { collectionModel } from './_variables';
import Collection from './Modules/Collection';


// COMPONENT
export default function Collections (props) {
   // States and Variables
   const [collections, setCollections] = useState(null);
   const [collectionPopups, setCollectionPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Collections");  // set page title
      getCollections();
   }, []);

   // Functions
   const getCollections = function () {
      OHSCRUD({
         url: '/v1/oneport/collections',
         method: 'GET',
         success: function (data) {
            setCollections(OHSListDataFormatter(data, collectionModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addCollection = function () {
      OHSCRUD({
         url: '/v1/oneport/collections',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-collections-add'),
         success: function (data) {
            if (collections.length > 0) {
               setCollections([...collections, OHSListDataFormatter(data[0], collectionModel)]);
            } else {
               setCollections([OHSListDataFormatter(data[0], collectionModel)]);
            }
            OHSFormDataClearer('oneport-collections-add');
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div className="oneport-collections">
         <OHSAppHeader onehive={props.onehive} title="Collections" help="https://www.onehivesystems.com/documentation/oneport/collections" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-collections-add' title="Add a Collection" onEnter={addCollection}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="SSH Username">
                  <input type='text' className='ohsinput' data-ohsformdata='ssh_username' placeholder='(Optional)' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="SSH Password">
                  <input type='password' className='ohsinput' data-ohsformdata='ssh_password' placeholder='(Optional)' />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addCollection} clear={() => {OHSFormDataClearer('oneport-collections-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Collections" container='oneport-collections-list' />
            <OHSWidget onehive={props.onehive} id='oneport-collections-list' title="List of Collections">
               <OHSList onehive={props.onehive} content={collections} popups={collectionPopups} setPopups={setCollectionPopups} template={
                  <Collection onehive={props.onehive} parent={{
                     collections: collections,
                     setCollections: setCollections
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}